'use client';
export function PreviewBanner({ isEnabled }: { isEnabled: boolean }) {
  if (!isEnabled) {
    return null;
  }

  const handleDisable = async () => {
    window.location.href = '/api/disable-preview';
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[99] bg-text-default text-brand-white shadow-lg">
      <div className="container mx-auto px-1 py-2 flex items-center justify-around">
        <div className="flex items-center gap-3">
          <span className="font-semibold">Preview Mode Active</span>
        </div>

        <button
          onClick={handleDisable}
          className="px-3 py-1 bg-brand-white text-text-default rounded-md font-medium text-headingxs lg:hover:bg-brand-grey-1 disabled:opacity-50 disabled:cursor-not-allowed transition-all"
        >
          {'Exit Preview'}
        </button>
      </div>
    </div>
  );
}
